import axios from "axios";
import { EntityServices } from "@sdk/utils/entity.service";
import type {
  iCustomerCreditVoucher,
  iCustomerCreditVoucherDetail,
} from "./customer-credit-voucher-model";

export class CustomerCreditVouchersServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
    this.customerCreditVouchers.configure(config);
  }

  constructor(protected config: { basePath: string; token: string }) {
    this.customerCreditVouchers = Object.assign(
      new EntityServices<iCustomerCreditVoucher>(
        config,
        "customer-credit-vouchers",
        {}
      ),
      {
        listForContact: async (contactId: string) => {
          const results = await axios.get<iCustomerCreditVoucher[]>(
            `${config.basePath}/contacts/${encodeURIComponent(
              contactId
            )}/customer-credit-vouchers`,
            {
              headers: { Authorization: config.token },
            }
          );
          return results.data;
        },
        getById: async (id: string) => {
          const results = await axios.get<iCustomerCreditVoucherDetail>(
            `${config.basePath}/customer-credit-vouchers/${encodeURIComponent(id)}`,
            {
              headers: { Authorization: config.token },
            }
          );
          return results.data;
        },
      }
    );
    this.customerCreditVouchers.configure(config);
  }

  customerCreditVouchers!: EntityServices<iCustomerCreditVoucher> & {
    listForContact: (contactId: string) => Promise<iCustomerCreditVoucher[]>;
    getById: (id: string) => Promise<iCustomerCreditVoucherDetail>;
  };
}
